import { createSelector } from '@reduxjs/toolkit';
import { isEmptyObjectHomrArray } from 'utility/utility';
import { ReduxState } from '../../types';

export const taxoSelector = (state: ReduxState) => state.taxonomy;

// selectors for original header taxo
export const headerTaxoSelector = (state: ReduxState) => state.taxonomy.header;
export const headerCTATaxoSelector = (state: ReduxState) => {
  const cta = state.taxonomy.header?.cta;
  if (!cta) {
    return undefined;
  }
  if (isEmptyObjectHomrArray(cta)) {
    return undefined;
  }
  return cta;
};
export const headerNavItemsSelector = (state: ReduxState) => {
  const navBarItems = state.taxonomy.header.headerNavBar;
  if (!navBarItems) {
    return undefined;
  }
  if (isEmptyObjectHomrArray(navBarItems)) {
    return undefined;
  }
  return navBarItems;
};
export const headerTaxoCategoriesSelector = (state: ReduxState) => {
  const taxonomy = state.taxonomy.header.Taxonomy2;
  if (!taxonomy) {
    return undefined;
  }
  if (isEmptyObjectHomrArray(taxonomy)) {
    return undefined;
  }
  return taxonomy;
};
export const headerTaxoTrendingSearchesSelector = (state: ReduxState) => {
  const { trendingSearches } = state.taxonomy.header;
  if (!trendingSearches) {
    return undefined;
  }
  if (!Array.isArray(trendingSearches) || trendingSearches.length < 1) {
    return undefined;
  }
  return trendingSearches[0];
};
export const headerClientLoadingSelector = (state: ReduxState) =>
  state.taxonomy.headerClientLoading;

// selectors for the progressive taxo
export const progressiveHeaderTaxoSelector = (state: ReduxState) =>
  state.taxonomy.progressiveHeader;
export const progressiveHeaderCTATaxoSelector = (state: ReduxState) => {
  const cta = state.taxonomy.progressiveHeader?.cta;
  if (!cta) {
    return undefined;
  }
  if (isEmptyObjectHomrArray(cta)) {
    return undefined;
  }
  return cta;
};
export const progressiveHeaderNavItemsSelector = (state: ReduxState) => {
  const navBarItems = state.taxonomy.progressiveHeader?.headerNavBar;
  if (!navBarItems) {
    return undefined;
  }
  if (isEmptyObjectHomrArray(navBarItems)) {
    return undefined;
  }
  return navBarItems;
};
export const progressiveHeaderTaxoCategoriesSelector = (state: ReduxState) => {
  const taxonomy = state.taxonomy.progressiveHeader?.Taxonomy2;
  if (!taxonomy) {
    return undefined;
  }
  if (isEmptyObjectHomrArray(taxonomy)) {
    return undefined;
  }
  return taxonomy;
};
export const progressiveHeaderTaxoTrendingSearchesSelector = (state: ReduxState) => {
  const trendingSearches = state.taxonomy.progressiveHeader?.trendingSearches;
  if (!trendingSearches) {
    return undefined;
  }
  if (!Array.isArray(trendingSearches) || trendingSearches.length < 1) {
    return undefined;
  }
  return trendingSearches[0];
};
export const progressiveHeaderClientLoadingSelector = (state: ReduxState) =>
  state.taxonomy.progressiveHeaderClientLoading;

// selectors for header-featured
export const headerFeaturedTaxoSelector = (state: ReduxState) => state.taxonomy.headerFeatured;

// selectors for the footer
export const footerTaxoSelector = (state: ReduxState) => state.taxonomy.footer;
export const footerTaxoLinksSelector = (state: ReduxState) => {
  const links = state.taxonomy.footer['Footer Links'];
  if (!links) {
    return undefined;
  }
  if (!Array.isArray(links) || links.length < 1) {
    return undefined;
  }
  return links[0];
};
export const footerTaxoCtaSelector = createSelector(footerTaxoLinksSelector, (links) => links?.cta);
export const footerTaxoLinkColumnsSelector = createSelector(
  footerTaxoLinksSelector,
  (links) => links?.csvData,
);
export const footerTaxoMessagingSelector = (state: ReduxState) =>
  state.taxonomy.footer.footerV2Messaging;
export const footerTaxoEmailSignUpSelector = (state: ReduxState) =>
  state.taxonomy.footer.footerEmailSignup;
export const footerClientLoadingSelector = (state: ReduxState) =>
  state.taxonomy.footerClientLoading;
